import { ChartModel } from './chart.model';
/**
 * Pie chart model definition
 */
export class PieChartModel extends ChartModel {
/**
 * Should pie chart to be like normal circle (true) or filled circle(false). Default: false.
 */
donut?: boolean;
/**
 * Show or hide the labels. Default: true.
 */
showLabels?: boolean;
/**
 * Make the radius of each slice proportional to it's value. Default: false.
 */
explodeSlices?: boolean;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super();
    Object.assign(this, values);
  }
}

function PieChartModel_tsickle_Closure_declarations() {
/**
 * Should pie chart to be like normal circle (true) or filled circle(false). Default: false.
 * @type {?}
 */
PieChartModel.prototype.donut;
/**
 * Show or hide the labels. Default: true.
 * @type {?}
 */
PieChartModel.prototype.showLabels;
/**
 * Make the radius of each slice proportional to it's value. Default: false.
 * @type {?}
 */
PieChartModel.prototype.explodeSlices;
}

